import { Globe } from 'lucide-react'
import ThemeSwitch from '../../components/ThemeSwitch'
import { otherLocale, setLocale } from '../../lib/i18n'

/**
 * The head of an auth card: the mark and the culture switch on one line, then
 * the title and the app name under them.
 *
 * The switch used to float over the background at the corner of the page,
 * which put a control outside the only object on screen that takes input — on
 * a phone, where the artwork is hidden, it sat alone on an empty field. It
 * belongs to the card, opposite the mark, where the two together read as the
 * card's identity row.
 *
 * The switch always names the language you would GET, in that language's own
 * script — which is what the legacy pages do, and what makes a two-language
 * control readable to someone who cannot read the language currently on screen.
 *
 * @param {import('react').ReactNode} mark   logo plate, or the OTP badge
 */
export default function AuthHead({ mark, title, subtitle }) {
  return (
    <header className="auth__head">
      <div className="auth__identity">
        {mark ?? <span />}

        {/* Both preferences sit here, before sign-in, because both have to be
            settable by someone who does not yet have an account to store them
            against — and because a login screen is where a dark-theme user
            first meets the app. */}
        <div className="auth__prefs">
          <ThemeSwitch />

          <button
            type="button"
            className="auth__language"
            onClick={() => setLocale(otherLocale.code)}
            lang={otherLocale.code}
            dir={otherLocale.dir}
            aria-label={otherLocale.label}
          >
            <Globe size={13} aria-hidden="true" />
            {otherLocale.label}
          </button>
        </div>
      </div>

      <h1 className="auth__title">
        <bdi>{title}</bdi>
      </h1>
      {subtitle && (
        <p className="auth__subtitle">
          <bdi>{subtitle}</bdi>
        </p>
      )}
    </header>
  )
}
